import { render } from "./AuthorizationList.vue?vue&type=template&id=6ef73828"
import script from "./AuthorizationList.vue?vue&type=script&lang=js"
export * from "./AuthorizationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__